export default __webpack_public_path__ + "static/media/TheWorldRussia_10.f26bcce5.png";